import * as PIXI from "pixi.js";
import UIFacade from "../UIFacade";
import DynamicTextComponent from "@baseUI/component/text/DynamicTextComponent";

import Watches from "@baseUI/component/specials/Watches";
import ButtonComponent from "@baseUI/component/button/ButtonComponent";
import ConfigTextures from "@baseUI/config/ConfigTextures";
import ActiveBets from "@baseUI/component/specials/ActiveBets";
import StateButtonComponent from "@baseUI/component/button/StateButtonComponent";
import StateOneButtonComponent from "@baseUI/component/button/StateOneButtonComponent";
import UISignals from "@baseUI/controllers/UISignals";
import {Scrollbox} from "pixi-scrollbox";
import {set} from "lodash";

export default new class UICreatorComponent {
    constructor () {}


    addContainer = (parent, settings = {} ) => {
        let mc = new PIXI.Container()
        if(parent instanceof Scrollbox){
            parent.content.addChild(mc)
            parent.update();
        } else {
            parent.addChild(mc);
        }
        Object.assign(mc,settings)
        return mc
    }

    addScrollableContainer = (parent, settings = {} ) => {
        let mc = new Scrollbox({boxWidth: settings.width, boxHeight: settings.height})
        parent.addChild(mc)
        Object.assign(mc,settings)
        return mc
    }

    addElement = (name, container, position, scale = 1, anchor = [0,0] ) => {
        let mc = new PIXI.Sprite(PIXI.Texture.from(name))
        if ( scale !== 1){
            mc.scale.set(scale)
        }
        mc.anchor.set(...Object.values(anchor))
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addElementOld = (name, container, position, pref, scale = 1) => {
        const path = pref ? pref + '/' + name : name
        let mc = new PIXI.Sprite(PIXI.Texture.from(path))
        if (scale !== 1) {
            mc.scale.set(scale)
        }
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    /*
        addButton = ( stateBtn, container, position, pref, scale = 1 ) => {
            const path = pref ? pref + '/' : ''
            let btn = new PIXI.AnimatedSprite([
                PIXI.Texture.from(path + stateBtn.normal),
                PIXI.Texture.from(path + stateBtn.over),
                PIXI.Texture.from(path + stateBtn.down),
                PIXI.Texture.from(path + stateBtn.disable)
            ])
            if ( scale !== 1){
                btn.scale.set(scale)
            }
            container.addChild(btn)
            if (position) {
                btn.position.set(...position)
            }
            return btn
        }

        addSimpleButton = ( stateBtn, container, position, pref ) => {
            return this.addButton({normal: stateBtn.active, over: stateBtn.active,
                                            down: stateBtn.active, disable: stateBtn.inactive}, container, position, pref)
        }
    */

    addElementDynamicTextName = (name, container, position, anchor =  0.5) => {
        const mc = new DynamicTextComponent(name)
        container.addChild(mc)
        if (position) {
            mc.position.set(...position)
        }
        return mc
    }

    addButton = ( nameStateBtn, container, position ) => {
        const textures = ConfigTextures.names[nameStateBtn]
        const btnState = new ButtonComponent(textures)
        container.addChild(btnState)
        if (position) {
            btnState.position.set(...Object.values(position))
        }
        return btnState
    }

    addButtonHitArea = ( nameStateBtn, container, position, hitArea ) => {
        const textures = ConfigTextures.names[nameStateBtn]
        const btnState = new ButtonComponent(textures, hitArea)
        container.addChild(btnState)
        if (position) {
            btnState.position.set(...Object.values(position))
        }
        return btnState
    }

    addWatches = ( styleName, container, position ) => {
        const style = UIFacade.textFactory.getStyle(styleName)
        const watch = new Watches(style)
        container.addChild(watch)
        if (position) {
            watch.position.set(...position)
        }
        return watch
    }

    addActiveBets = ( container, position ) => {
        const activeBets = new ActiveBets()
        container.addChild(activeBets)
        if (position) {
            activeBets.position.set(...position)
        }
        return activeBets
    }

    addListenerButton(name, key, panel, position, hitArea){
        const btn = hitArea ? this.addButtonHitArea(name, panel, position, hitArea) : this.addButton(name, panel, position)

        btn.on('tapButton', ()=>{
            console.log('btn', key)
            document.dispatchEvent(new CustomEvent('tap', {detail: {name: key}}))
        })
        return btn
    }

    addStateButton = ( nameStateBtn, container, position ) => {
        const textures = ConfigTextures.names[nameStateBtn].states
        const btnState = new StateButtonComponent(textures)
        container.addChild(btnState)
        if (position) {
            btnState.position.set(...position)
        }
        return btnState
    }

    addListenerStateButton = ( nameStateBtn, key, container, position ) => {
        const btnState = this.addStateButton(nameStateBtn, container, position)
        btnState.on('tapButton', ()=>{
            console.log('btn', key)
            UISignals.setStateSettings.dispatch(key, btnState.stateStatus)
         //   document.dispatchEvent(new CustomEvent('tap', {detail: {name: key}}))
        })
        return btnState
    }

    addStateOneButton = ( nameStateBtn, container, position ) => {
        const textures = ConfigTextures.names[nameStateBtn].states
        const btnState = new StateOneButtonComponent(textures)
        container.addChild(btnState)
        if (position) {
            btnState.position.set(...position)
        }
        return btnState
    }

    addListenerStateOneButton = ( nameStateBtn, key, container, position ) => {
        const btnState = this.addStateOneButton(nameStateBtn, container, position)
        btnState.on('tapButton', ()=>{
            console.log('btn', key)
            UISignals.setStateMenu.dispatch(key)
            //document.dispatchEvent(new CustomEvent('tap', {detail: {name: key}}))
        })
        return btnState
    }


}()
